export const config = {
    prop: 1
}